module.exports = __webpack_public_path__ + "a4572996ecf29355e9fb67b3473a7d43.png";